import { HttpEventType, HttpResponse } from "@angular/common/http";
import { Component, OnInit, AfterViewInit, ElementRef, inject, input, viewChild, signal, ViewEncapsulation } from "@angular/core";
import { FormGroup, UntypedFormBuilder, Validators, FormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService, PrimeTemplate } from "primeng/api";
import { Observable } from "rxjs";
import { ApiResponse } from "src/app/models/api-response.";
import { Rooms } from "src/app/models/rooms";
import { Rooms_images } from "src/app/models/rooms_images";
import { RoomsImagesService } from "src/app/services/rooms_images.service";
import { environment } from "src/environments/environment";
import { Bind } from "primeng/bind";
import { Toast } from "primeng/toast";
import { TableModule } from "primeng/table";
import { InputText } from "primeng/inputtext";
import { ButtonDirective } from "primeng/button";
import { DatePipe } from "@angular/common";
import { ProgressBar } from "primeng/progressbar";

import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-upload",
    templateUrl: "./upload.component.html",
    styleUrl: "./upload.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [TPipe, Bind, Toast, TableModule, PrimeTemplate, FormsModule, InputText, ButtonDirective, ProgressBar, DatePipe]
})
export class UploadComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private messageService = inject(MessageService);
  private router = inject(Router);
  private confirmationService = inject(ConfirmationService);
  private route = inject(ActivatedRoute);
  private roomsImagesService = inject(RoomsImagesService);

  readonly element = input<any>(undefined);
  readonly room = input<any>(undefined);

  readonly myInputVariable = viewChild<ElementRef>("myInput");
  blogForm: FormGroup;
  images: any;
  readonly error = signal<string>(undefined);
  readonly selectedFiles = signal<FileList>(undefined);
  readonly progressInfos = signal<any[]>([]);
  readonly message = signal<string[]>([]);
  readonly previews = signal<string[]>([]);
  readonly uploadError = signal<string>(undefined);
  cols: any[];
  path = environment.imageUrl;
  imagePath: any;
  count: 0;
  readonly imageInfos = signal<Rooms_images[]>([]);
  id: string;

  ngOnInit(): void {
    this.roomsImagesService.list({ product_id: this.room() }).subscribe((pData: Rooms_images[]) => {
      this.imageInfos.set(pData);
    });
  }

  selectFiles(event: any): void {
    this.message.set([]);
    this.progressInfos.set([]);
    this.selectedFiles.set(event.target.files);
    this.previews.set([]);

    if (this.selectedFiles() && this.selectedFiles()[0]) {
      const numberOfFiles = this.selectedFiles().length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.previews.update((a) => { a.push(e.target.result); return [...a]; });
        };

        reader.readAsDataURL(this.selectedFiles()[i]);
      }
    }
  }

  upload(idx: number, file: File): void {
    this.progressInfos()[idx] = { value: 0, fileName: file.name };

    if (file) {
      const id = this.route.snapshot.paramMap.get("id");

      this.roomsImagesService.upload(file, this.room()).subscribe({
        next: (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos()[idx].value = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event instanceof HttpResponse) {
            const msg = "Uploaded the file successfully: " + file.name;
            this.message.update((a) => { a.push(msg); return [...a]; });

            this.roomsImagesService.list({ product_id: this.room() }).subscribe((pData: Rooms_images[]) => {
              this.imageInfos.set(pData);
            });

            this.previews.set([]);
            this.progressInfos.set([]);
            this.resetFileInput();
            setTimeout(() => {
              this.message.set([]);
            }, 1500);
          }
        },
        error: (err: any) => {
          this.progressInfos()[idx].value = 0;
          const msg = "Could not upload the file: " + file.name;
          this.message.update((a) => { a.push(msg); return [...a]; });
        },
      });
    }
  }

  uploadFiles(): void {
    this.message.set([]);

    if (this.selectedFiles()) {
      for (let i = 0; i < this.selectedFiles().length; i++) {
        this.upload(i, this.selectedFiles()[i]);
      }
    }
  }

  resetFileInput(): void {

    this.selectedFiles.set(undefined);
    const myInputVariable = this.myInputVariable();
    if (myInputVariable && myInputVariable.nativeElement) {
      myInputVariable.nativeElement.value = "";
    }
  }

  onDeleteImage(image_id: any, image_name: any, page_id: any) {
    this.confirmationService.confirm({
      message: `Sei sicuro di volerlo cancellare = ${image_name}`,
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.roomsImagesService.delete(image_id).subscribe(
          (res: ApiResponse) => {
            if (res.status === "error") {
              this.messageService.add({
                key: "myKeyUpload",
                severity: "error",
                summary: "Errore",
                detail: `Cancellazione non riuscita: ${res.message || 'Errore sconosciuto'}`,
              });
            } else {
              this.messageService.add({
                key: "myKeyUpload",
                severity: "success",
                summary: "Attenzione",
                detail: "Cancellazione avvenuta con successo",
              });

              this.roomsImagesService.list({ product_id: this.room() }).subscribe(
                (pData: Rooms_images[]) => {
                  this.imageInfos.set(pData);
                },
                (error) => {
                  this.error.set(error);
                  this.messageService.add({
                    key: "myKeyUpload",
                    severity: "error",
                    summary: "Errore",
                    detail: "Impossibile aggiornare l'elenco delle immagini",
                  });
                }
              );
            }
          },
          (error) => {
            this.messageService.add({
              key: "myKeyUpload",
              severity: "error",
              summary: "Errore",
              detail: "Impossibile completare la cancellazione",
            });
          }
        );
      },
    });
  }

  onRowEditSave(image: any) {
    const formData = new FormData();
    formData.append("description", image.description);
    formData.append("image_order", image.image_order);

    const id = image.id;

    this.roomsImagesService.update(formData, id).subscribe(
      (res) => {
        if (res.status == "error") {
          this.messageService.add({
            key: "myKey1",
            severity: "warn",
            summary: "Informazioni",
            detail: "Errore",
          });
          this.uploadError.set(res.message);
        } else {
          this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Attenzione', detail: 'Salvato con sucesso' });
          this.roomsImagesService.list({ product_id: this.element().id }).subscribe((pData) => {
            this.imageInfos.set(pData);
          });
        }
      },
      (error) => (this.error.set(error))
    );
  }

  onRowEditInit(image: any) {
    this.imageInfos()[image.image_id] = { ...image };
  }
}
